/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wb_GInputs */

const en_tut_wb_g = /** @type {(inputs: Tut_Wb_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When a discussion is easier drawn than written, open a whiteboard. It always belongs to a meeting, a document, or an office area — never a link standing on its own.`)
};

const id_tut_wb_g = /** @type {(inputs: Tut_Wb_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalau diskusi lebih mudah digambar daripada ditulis, buka papan tulis. Ia selalu menempel pada rapat, dokumen, atau area kantor — bukan tautan yang berdiri sendiri.`)
};

/**
* | output |
* | --- |
* | "When a discussion is easier drawn than written, open a whiteboard. It always belongs to a meeting, a document, or an office area — never a link standing on i..." |
*
* @param {Tut_Wb_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wb_g = /** @type {((inputs?: Tut_Wb_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wb_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wb_g(inputs)
	return en_tut_wb_g(inputs)
});